import type { Include, SingleObjectInclude } from '@shared/types/ApiResponse';
import type { CreateRoute, DestroyRoute, EditRoute, IndexRoute, ShowRoute, StoreRoute, UpdateRoute } from '@shared/types/Route';
import { type IPayout, Payout } from '@app/purchase/payout/models/Payout';
import type { IOwner } from '@app/land-hold/owner/models/Owner.ts';
import type { IPayoutEvent } from '../../bundle/models/PayoutEvent.ts';
import type { IBlock } from '@app/purchase/block/models/Block.ts';
import type { ITransaction } from '@app/purchase/transaction/models/Transaction.ts';

export const AvailableIncludes = {
    Owner: 'owner',
    Bundle: 'bundle',
    Block: 'block',
    Transaction: 'transaction',
} as const;

type OwnerInclude = Include<typeof AvailableIncludes, 'owner', IOwner, SingleObjectInclude<IOwner> | null>;
type BundleInclude = Include<typeof AvailableIncludes, 'bundle', IPayoutEvent, SingleObjectInclude<IPayoutEvent> | null>;
type BlockInclude = Include<typeof AvailableIncludes, 'block', IBlock, SingleObjectInclude<IBlock> | null>;
type TransactionInclude = Include<typeof AvailableIncludes, 'transaction', ITransaction, SingleObjectInclude<ITransaction> | null>;

export type AllPayoutIncludes = IPayout & OwnerInclude & BundleInclude & BlockInclude & TransactionInclude;
export type IndexPayoutIncludes = IPayout & OwnerInclude & BundleInclude & BlockInclude & TransactionInclude;
export type ShowPayoutIncludes = IndexPayoutIncludes;

export function routes(): {
    index: IndexRoute<'payouts.index', IndexPayoutIncludes>;
    show: ShowRoute<'payouts.show', ShowPayoutIncludes>;
    destroy: DestroyRoute<'payouts.destroy'>;
    create: CreateRoute<'payouts.create'>;
    store: StoreRoute<'payouts.store'>;
    edit: EditRoute<'payouts.edit'>;
    update: UpdateRoute<'payouts.update'>;
} {
    return {
        index: {
            method: 'get',
            name: 'payouts.index',
            params: {
                include: [AvailableIncludes.Owner, AvailableIncludes.Bundle, AvailableIncludes.Block, AvailableIncludes.Transaction],
                orderBy: 'created_at',
                sortedBy: 'desc',
            },
            datatableHeaders: () => Payout.headers(),
            page: usePage(),
        },
        show: {
            method: 'get',
            name: 'payouts.show',
            params: {
                include: [AvailableIncludes.Owner, AvailableIncludes.Bundle, AvailableIncludes.Block, AvailableIncludes.Transaction],
            },
            page: usePage(),
        },
        destroy: { method: 'delete', name: 'payouts.destroy', page: usePage() },
        create: { method: 'get', name: 'payouts.create', page: usePage() },
        store: { method: 'post', name: 'payouts.store', page: usePage() },
        edit: { method: 'get', name: 'payouts.edit', page: usePage() },
        update: { method: 'patch', name: 'payouts.update', page: usePage() },
    };
}
